import { createAsyncThunk } from '@reduxjs/toolkit';

import { CatalogItemInOrder } from 'entities/CatalogItem/model/types/CatalogItemSchema';

import { DeleteItemsInOrderRequestParams } from '../../types/removeItemsInOrderSchema';

import type { ThunkConfig } from 'app/providers/StoreProvider/config/types';

export const deleteOrderItem = createAsyncThunk<
    CatalogItemInOrder,
    DeleteItemsInOrderRequestParams,
    ThunkConfig<string>
>('order/deleteOrderItem', async ({ orderId, itemId }, thunkApi) => {
    const { extra, rejectWithValue } = thunkApi;

    try {
        const response = await extra.api.delete<CatalogItemInOrder>(
            `/v1/orders/${orderId}/items/${itemId}`,
        );

        return response.data;
    } catch (e) {
        return rejectWithValue('error');
    }
});
